import { getCurrentPipeline } from 'src/components/pipelines/redux/selectors/pipelines';
import {
  capturePipelinesExceptionWithTags,
  createErrorMessage,
  SentryPipelinesTeam,
} from 'src/components/pipelines/utils/sentry';
import { BucketState } from 'src/types/state';
import { authRequest } from 'src/utils/fetch';

export async function fetchData(
  url: string,
  exceptionSegment: string,
  options: RequestInit = {},
  responseType: 'json' | 'text' = 'json',
  teamName?: SentryPipelinesTeam
): Promise<any> {
  try {
    const req = authRequest(url, options);
    const resp = await fetch(req);

    if (!resp.ok) {
      throw new Error(await createErrorMessage(resp));
    }

    const data =
      responseType === 'json' ? await resp.json() : await resp.text();
    return data;
  } catch (e) {
    capturePipelinesExceptionWithTags(e, {
      segment: exceptionSegment,
      ...(teamName ? { teamName } : {}),
    });
    throw e;
  }
}

export const hasFetchedPipeline = (state: BucketState): boolean => {
  return !!getCurrentPipeline(state).uuid;
};

export const stepsFetchedForCurrentRun = (
  state: BucketState,
  runUuid?: string | null
): boolean => {
  return runUuid === state.pipelines.steps.stepsFetchedForPipelineRunUuid;
};

export const getSteps = (state: BucketState): any => {
  return state.pipelines.steps.map;
};
